import { TFunction } from "i18next";
import camelCase from "lodash/camelCase";

import { SubscriptionProduct } from "gql/generated.graphql";
import { getChangeType } from "common/helpers";
import { SubscriptionProductModel } from "dash-common";

export const getModalConfirmationTextLabels = (
  {
    oldProduct,
    newProduct,
  }: {
    oldProduct: SubscriptionProductModel;
    newProduct: SubscriptionProductModel;
  },
  { t }: { t: TFunction }
): { titleLabel: string; descriptionLabel: string; buttonLabel: string } => {
  const billingKey = "pages:profilePage.billing.changePlanConfirmationModal";

  const labelMap = {
    upgrade: "upgradeTitle",
    downgrade: "downgradeTitle",
    month: "changeToMonthlyPlan",
    sixmonth: "changeToSixMonthPlan",
  };

  const buttonLabelMap = {
    upgrade: "upgradeButton",
    downgrade: "downgradeButton",
    month: "yesButton",
    sixmonth: "yesButton",
  };

  const changeType = getChangeType(oldProduct, newProduct);
  const prefixLabel = labelMap[changeType.toLowerCase()];
  const buttonLabel = buttonLabelMap[changeType.toLowerCase()];
  
  const isSameRecurring =
    newProduct?.recurringType === oldProduct?.recurringType;

  const getProductName = (product: SubscriptionProduct): string => {
    if (isSameRecurring) {
      return product?.name;
    }

    return `${t(
      `common:subscriptionProductRecurringLabels.${camelCase(
        product?.recurringType
      )}`
    ).toLowerCase()} ${product?.name}`;
  };

  const newProductLabel = getProductName(newProduct);

  return {
    titleLabel: t(`${billingKey}.${prefixLabel}`, {
      name: newProductLabel,
    }),
    descriptionLabel: t(`${billingKey}.changeDescription`, {
      old: getProductName(oldProduct),
      new: newProductLabel,
    }),
    buttonLabel: t(`${billingKey}.${buttonLabel}`),
  };
};
